export const LOAD = 'ethstats/avgBlockTime/LOAD';
export const LOAD_SUCCESS = 'ethstats/avgBlockTime/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/avgBlockTime/LOAD_FAIL';
